/* global $ */
// eslint-disable-next-line no-unused-vars
import slick from 'slick-carousel';

class Slider {
  constructor(gallerySelector, currentSlide) {
    this.gallerySlider = $(gallerySelector);
    this.currentSlide = currentSlide;
    this.numSlides;
    this.mobileBreakpoint = 768;

    this.init();
  }

  init() {
    this.gallerySlider.slick({
      dots: false,
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: this.mobileBreakpoint,
          settings: 'unslick',
        },
      ],
    });

    this.numSlides = $('.slick-slide:not(.slick-cloned)').length;
    this.gallerySlider.slick('slickGoTo', this.currentSlide, true);
    this.gallerySlider
      .find('.slick-list')
      .attr('tabindex', 0)
      .focus();

    this.gallerySlider.on('afterChange', (event, slick, currentSlide) => {
      $('.slick-page-count').text(`${currentSlide + 1} / ${this.numSlides}`);
    });

    this.createPagination();
  }

  createPagination() {
    const $pagination = $(document.createElement('p'))
      .addClass('slick-page-count')
      .text(`${this.currentSlide + 1} / ${this.numSlides}`);

    $pagination.appendTo(this.gallerySlider);
  }

  isInitialized() {
    return this.gallerySlider.hasClass('slick-initialized');
  }

  resize() {
    this.gallerySlider.slick('setPosition');
  }

  deinit() {
    this.gallerySlider.slick('unslick');
  }
}

export default Slider;
